import type { EventFromLogic, SnapshotFrom } from "xstate";
import { getShortestPaths, type StatePath } from "xstate/graph";

import type { LitigationMachine } from "../types";
import { v1 } from "./v1";

const versions = {
  1: v1,
};

/** Quick & Dirty way to preserve Typescript's types ; Ok for now */
function getMachine(versionNumber: number) {
  if (versionNumber === 1) {
    return v1;
  }
}

function findShortestPathToEvent<TMachine extends LitigationMachine>(
  machine: TMachine,
  fromState: SnapshotFrom<TMachine>,
  eventType: EventFromLogic<TMachine>["type"],
): Array<EventFromLogic<TMachine>> | undefined {
  const paths = getShortestPaths(machine, {
    fromState,
    // Collapse the state-space to state value only — context.LEGAL_STEP changes
    // would otherwise be treated as distinct nodes and explode the BFS.
    serializeState: (snap) => JSON.stringify(snap.value),
  }) as Array<StatePath<SnapshotFrom<TMachine>, EventFromLogic<TMachine>>>;

  let best: Array<EventFromLogic<TMachine>> | undefined;
  for (const path of paths) {
    const lastStep = path.steps[path.steps.length - 1];

    if (lastStep?.event.type !== eventType) {
      continue;
    }

    // xstate v5's `alterPath` prepends a synthetic `xstate.init` step
    // representing "start at fromState". Strip it to get the real events.
    const events = path.steps.slice(1).map((step) => step.event);

    if (!best || events.length < best.length) {
      best = events;
    }
  }
  return best;
}

export { getMachine, versions, findShortestPathToEvent };
